import { render, staticRenderFns } from "./GKBreadcrumbs.vue?vue&type=template&id=0d6f05ac&scoped=true&"
import script from "./GKBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./GKBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./GKBreadcrumbs.vue?vue&type=style&index=0&id=0d6f05ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6f05ac",
  null
  
)

export default component.exports